import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IDegree } from "../degreeSlice";

export const getAllDegree = createAsyncThunk(
  "Degree/FindAllDegree",
  async (title?: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Degree/FindAllDegree`,
        {
          Title: title || "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Degrees:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createDegree = createAsyncThunk(
  "Degree/InsertDegree",
  async (degreeData: Omit<IDegree, "ID">) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Degree/InsertDegree`,
        degreeData,
      );
      SuccessToast(response.data?.Details || "Degree created successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Degree:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateDegree = createAsyncThunk(
  "Degree/UpdateDegree",
  async (degreeData: IDegree) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Degree/UpdateDegree`,
        degreeData,
      );
      SuccessToast(response.data?.Details || "Degree updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Degree:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteDegree = createAsyncThunk(
  "Degree/DeleteDegree",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Degree/DeleteDegree`,
        {
          ID,
        },
      );
      SuccessToast(response.data?.Details || "Degree deleted successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Degree:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getDegreeByID = createAsyncThunk(
  "Degree/FindByIDDegree",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Degree/FindByIDDegree`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        IsActive: result.IsActive ? 1 : 2,
      } as IDegree;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Degree:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveDegree = createAsyncThunk(
  "Degree/FindAllActiveDegree",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Degree/FindAllActiveDegree`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Degrees:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveDegree = createAsyncThunk(
  "Degree/ActiveInActiveDegree",
  async (formData: { ID: number; IsActive: boolean }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Degree/ActiveInActiveDegree`,
        formData,
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error toggling Degree status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
